(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Country'];

    function CountryDetailController($scope, $rootScope, $stateParams, entity, Country) {
        var vm = this;

        vm.country = entity;

        var unsubscribe = $rootScope.$on('portalApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
